export default __webpack_public_path__ + "static/media/b8f7f313d5dd67745ee7182ce90a2ff21579016881911.b33b71cd.webp";